<template>
  <ValidationProvider
    :ref="name"
    :name="name"
    :vid="name"
    :rules="rules"
    :mode="validationMode"
    slim
    v-slot="{ errors }"
  >
    <v-text-field
      v-model="model"
      :name="name"
      :label="`${label} ${requiredHint}`"
      :placeholder="placeholder"
      :error-messages="errors[0]"
      v-bind="{...input}"
      :style="customStyle"
      :maxlength="maxLength"
      :disabled="disabled"
    />
  </ValidationProvider>
</template>

<script>
import _ from 'lodash'
import {getFieldRules} from '@/utils/auth/validation'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 524288
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value.trim())
      },
    },
    name() {
      return _.get(this.component, 'name', '')
    },
    label() {
      return _.get(this.component, 'label', '')
    },
    placeholder() {
      return _.get(this.component, 'placeholder', '')
    },
    requiredHint() {
      return _.get(this.component, 'required', false) ? '*' : ''
    },
    disabled() {
      return _.get(this.component, 'disabled', false)
    },
    rules() {
      return getFieldRules(this.component)
    },
    validationMode() {
      return _.get(this.component, 'validationMode', 'eager')
    },
    // https://vuetifyjs.com/en/api/v-text-field/
    input() {
      return _.get(this.component, 'props.input', {})
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    }
  },
  created() {
    this.$emit('field-registered', this.name)
  },
}
</script>

<style lang="scss" scoped></style>
